import { render, staticRenderFns } from "./AdminUserCard.vue?vue&type=template&id=160c9eb9&scoped=true"
import script from "./AdminUserCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUserCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AdminUserCard.vue?vue&type=style&index=0&id=160c9eb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160c9eb9",
  null
  
)

export default component.exports